import { useEffect, useState, useCallback } from "react";
import { Box, Stack, Typography } from "@mui/material";
import ContentTile from "./ContentTile";
import { useDispatch } from "../../../redux/store";
import { setSelectedContent } from "../../../redux/slices/creator";
import { useLazyGetRecentContentForCreatorQuery } from "../../../redux/apiSlices/discover";
import {
  triggerGa,
  CATEGORY,
  ACTION,
  PAGE,
  SCREEN,
  LABEL,
  LABEL2,
} from "../../../utils/gaUtils";
import RecentContentSkeleton from "./RecentContentSkeleton";
import colors from "../../../config/colors";

const TopContent = ({ wishlink_username, instagram_username = "" }) => {
  const [content, setContent] = useState([]);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const dispatch = useDispatch();
  const [fetchIGPosts] = useLazyGetRecentContentForCreatorQuery();

  const loadTopContent = useCallback(async () => {
    if (!wishlink_username) return;

    setIsInitialLoading(true);
    try {
      const result = await fetchIGPosts({ wishlink_username }).unwrap();
      const posts = Array.isArray(result) ? result : result?.data || [];
      setContent(posts.slice(0, 5));
    } catch (e) {
      console.error("Error loading top content:", e);
      setContent([]);
    } finally {
      setIsInitialLoading(false);
    }
  }, [wishlink_username, fetchIGPosts]);

  const handleClickContent = (item) => {
    dispatch(setSelectedContent(null));
    setTimeout(() => {
      triggerGa({
        category: CATEGORY.USER_INTERACTION,
        action: ACTION.POPULAR_AFFILIATE_CLICK,
        label: instagram_username,
        label2: item?.permalink,
        label3: LABEL2.PROFILE_INTEREST,
        page: PAGE.CREATOR_DISCOVER,
        screenName: SCREEN.CREATOR_DRAWER,
      });
      dispatch(setSelectedContent(item));
    }, 100);
  };

  useEffect(() => {
    loadTopContent();
  }, [loadTopContent]);

  if (isInitialLoading) {
    return <RecentContentSkeleton label="Popular Affiliate Post" />;
  }
  if (content?.length === 0) {
    return (
      <Box>
        <Typography fontSize={12} mb={1}>
          Popular Affiliate Post:
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "139px",
          }}
        >
          <Typography
            variant="body2"
            color={colors.gray200}
            sx={{ textAlign: "center" }}
          >
            No popular affiliate post available.
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Typography fontSize={12} fontWeight={500} lineHeight="20px" mb={1}>
        Popular Affiliate Post:
      </Typography>

      <Stack direction="row" gap={1} sx={{ flexWrap: "wrap" }}>
        {content.map((item) => (
          <ContentTile
            key={
              item?.permalink ||
              item?.post_id ||
              item?.thumbnail_url ||
              item?.post_created
            }
            item={item}
            onClick={() => handleClickContent(item)}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default TopContent;
